export const PROJECT_TYPE = 'projectType'
export const projectType = {
  en: {
    translation: {
      [PROJECT_TYPE]: {
        //Page
        projectType: 'Location',
        //Table
        type: 'Location',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',

        // modal
        addProjectType: 'Add Location',
        newProjectType: 'New Location',
        editProjectType: 'Edit Location',
        save: 'Save',
        cancel: 'Cancel',
      },
    },
  },

  es: {
    translation: {
      [PROJECT_TYPE]: {
        //Page
        projectType: 'Location',
        //Table
        type: 'Location',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',

        // modal
        addProjectType: 'Add Location',
        newProjectType: 'New Location',
        editProjectType: 'Edit Location',
        save: 'Ahorrar',
        cancel: 'Cancelar',
      },
    },
  },
}
